import { render } from "./table.vue?vue&type=template&id=1dd33365&scoped=true"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"

import "./table.vue?vue&type=style&index=0&id=1dd33365&scoped=true&lang=css"

import exportComponent from "/home/jenkins-prod/worker1/workspace/jaka-digital/A-01-OTA/jaka-ota-admin-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dd33365"]])

export default __exports__